<template>
  <q-card class="q-pa-md">
    <div class="row q-col-gutter-lg">
      <div class="col-3">
        <q-img :src="preset.imageUrl" />
      </div>
      <div class="col-6">
        <div class="text-h6">
          {{ preset.label }}
        </div>
        <div class="text-body1">
          {{ preset.description}}
        </div>
      </div>
      <div class="col-3">
        <div class="text-center fit flex items-center justify-center">
          <ManageBtn
            :connection="connection"
            color="grey-5"
            size="lg"
            round
            unelevated
            no-caps
            @update:connection="$emit('update:connection', $event)"
          />
        </div>
      </div>
    </div>
  </q-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IntegrationConnection, IntegrationPreset } from '@/iam/types';
import ManageBtn from './connection/ManageBtn.vue';

export default defineComponent({
  emits: ['update:connection'],
  components: { ManageBtn },
  props: {
    preset: {
      type: Object as () => IntegrationPreset,
      required: true,
    },
    connection: {
      type: Object as () => IntegrationConnection,
      required: true,
    },
  },
});
</script>
